module.exports = __webpack_public_path__ + "media/images/pencil-blue-line-2-d0ee9d23d8c37d5ec43ad96d71f5cad4.png";